// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export default function isEmpty(obj: Record<string, any>): boolean {
  return Object.keys(obj).length === 0;
}
